import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar } from '@angular/material/snack-bar';
import { MessageService } from '@services/message.service';

@Injectable({
    providedIn: 'root',
})
export class LostNetworkService {
    optionsMessage = inject(MAT_SNACK_BAR_DEFAULT_OPTIONS);
    toast = inject(MessageService);
    platformId = inject(PLATFORM_ID);
    message = inject(MatSnackBar);

    constructor() {
        let closeToast: (() => void) | null = null;
        if (isPlatformBrowser(this.platformId)) {
            window.addEventListener('offline', () => {
                console.log('offline');
                closeToast = this.toast.warning('Сеть не доступна', {
                    timeOut: 1e6,
                });
            });
            window.addEventListener('online', () => {
                console.log('online');
                closeToast && closeToast();
                closeToast = null;
                this.toast.success('Подключение к сети восcтановлено');
            });
        }
    }
}
